import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { Button, Card, Col, Form, Modal, Row, Spinner, Table } from 'react-bootstrap';
import { CredentialService, IApiKey } from '../services/CredentialService';
import { useAuthContext } from '../contexts/AuthContext';

export const CredentialsPage = (props: any) => {
    const [apiKeys, setApiKeys] = React.useState<IApiKey[]>([]);
    const [showModal, setShowModal] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const authContext = useAuthContext();

    React.useEffect(() => {
        const getKeys = async () => {
            if(!authContext.user){
                return;
            }
            const response = await CredentialService.getApiKeys();
            if (!response.error) {
                setApiKeys(response.data.apiKeys);
            } else {
                props.apiError(true);
                props.showToast(true);
                props.toastMessage("Oops, something went wrong getting API keys");   //(JSON.stringify(response.data));
            }
            setIsLoading(false);
        }
        getKeys();
    }, []);

    const handleRequestApiKey = async () => {
        const response = await CredentialService.requestApiKey();
        if (!response.error) {
            const newKey: IApiKey = response.data;
            let keyExists = false;
            apiKeys.forEach((item) => {
                if (item.apiKey === newKey.apiKey) {
                    keyExists = true;
                }
            });
            if (keyExists === false) {
                setApiKeys([...apiKeys, newKey]);
                setShowModal(true);
            }
        } else {
            props.apiError(true);
            props.showToast(true);
            props.toastMessage("Oops, something went wrong creating API key");   //(JSON.stringify(response.data));
        }
    }

    return (<>
        {!authContext.user && <Redirect to="/login?redirectUrl=credentials" />}
        <main className="docs-wrapper">
            <div id="main-content">
                <h1 className="api-docs-h1 mt-3 mb-2">API Credentials</h1>
                <p className="text-gray mb-4">Create your API Keys by clicking the button below. Any questions? Feel free to reach out at <a href="mailto:support@bilflo.com">support@bilflo.com</a></p>
                <div className="mb-5">
                    <Button className="rounded-pill py-2 px-3" variant="success" onClick={handleRequestApiKey}><span className="fa-solid fa-plus mr-1"></span> Request API Key</Button>
                </div>
                <div className="d-flex flex-column mb-5">
                    <Table>
                        <thead>
                            <tr>
                                <th>API Name</th>
                                <th>Key</th>
                            </tr>
                        </thead>
                        {isLoading ? (
                            <tbody>
                                <tr>
                                    <td colSpan={2}><React.Fragment>
                                        <div className='text-center'>
                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                        </div>

                                    </React.Fragment></td>
                                </tr>
                            </tbody>
                        ) : (
                            <tbody>
                                {(apiKeys.length === 0) ?
                                    <tr>
                                        <td>No API Keys to display</td>
                                    </tr>
                                    :
                                    apiKeys.map((key: IApiKey, index: number) => {
                                        return (
                                            <tr key={"tr-" + index}>
                                                <td>{key.apiName}</td>
                                                <td>{key.apiKey}</td>
                                            </tr>
                                        );
                                    })
                                }
                            </tbody>
                        )}
                    </Table>
                </div>
                <div id="api-docs"></div>
            </div>
        </main>
        <Modal backdrop="static" centered keyboard={false} onHide={() => setShowModal(false)} show={showModal}>
            <Modal.Header>
                <Modal.Title>
                    API Key Created
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Use this API key by passing it in the header of all API calls as a bearer token like this:&nbsp;
                    <code>'Authorization: Bearer YourAPIKey'</code>
                </p>
                <Form.Group>
                    <Form.Label>Your API Key</Form.Label>
                    <Form.Control type="text" readOnly defaultValue={(apiKeys.length > 0) ? apiKeys[0].apiKey : ''} />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" className="rounded-pill" onClick={() => setShowModal(false)}>Got It</Button>
            </Modal.Footer>
        </Modal>
    </>);
};